import { CheckCircle2, Clock3 } from "lucide-react";
import { ContentAccordion } from "./ContentAccordion";
import { SectionHeading } from "./SectionHeading";
import { bonuses, everyVolumeIncludes, volumes } from "../../data/aquagym";
interface CurriculumSectionsProps {
  openItem: string;
  onOpenChange: (value: string) => void;
}
export function VolumesSection({
  openItem,
  onOpenChange
}: CurriculumSectionsProps) {
  return <section className="bg-[#F8FAFC] px-5 py-16 sm:px-8 sm:py-20 lg:px-10" data-id="element-31" data-mp="2787mkfynhfjx">
      <div className="mx-auto w-full max-w-5xl" data-id="element-32" data-mp="2byxqdorfhaci">
        <SectionHeading eyebrow="Producto principal" title="Los 7 tomos del sistema" description="Explorá cada tomo. Están organizados de forma progresiva para acompañar todo tu recorrido como instructor/a." data-id="element-33" data-mp="2c0s9cxj52sdy" />
        <div className="mt-10" data-id="element-34" data-mp="229nz2b4ervpg">
          <ContentAccordion entries={volumes} kind="volume" openItem={openItem} onOpenChange={onOpenChange} data-id="element-35" data-mp="1o9v9wk8j5njl" />
        </div>
        <aside className="mt-8 rounded-3xl border border-cyan-300/70 bg-[#ECFEFF] p-6 sm:p-8" data-id="element-36" data-mp="1t8zhx7jpxf8c">
          <h3 className="text-xl font-black text-[#0C4A6E] sm:text-2xl" data-id="element-37" data-mp="1b2nl0peiarm5">Cada tomo incluye:</h3>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-38" data-mp="172d62n8qkqv5">
            {everyVolumeIncludes.map(item => <li key={item} className="flex gap-3 text-sm leading-6 text-[#334155] sm:text-base" data-id="element-39" data-mp="1l0jt18c5d6g1">
                <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-[#0891B2]" aria-hidden="true" data-id="element-40" data-mp="1g3jmyxfas3ox" />
                {item}
              </li>)}
          </ul>
        </aside>
      </div>
    </section>;
}
export function BonusesSection({
  openItem,
  onOpenChange
}: CurriculumSectionsProps) {
  return <section className="bg-white px-5 py-16 sm:px-8 sm:py-20 lg:px-10" data-id="element-41" data-mp="123ilbfr7ks8e">
      <div className="mx-auto w-full max-w-5xl" data-id="element-42" data-mp="xbqt70semeg5">
        <SectionHeading eyebrow="Incluidos sin costo adicional" title="Los 5 bonos estratégicos" description="Recursos complementarios para aplicar el sistema y profesionalizar tu trabajo desde el primer día." data-id="element-43" data-mp="x9xkzh257m61" />
        <div className="mt-10" data-id="element-44" data-mp="4liifu076wbl">
          <ContentAccordion entries={bonuses} kind="bonus" openItem={openItem} onOpenChange={onOpenChange} data-id="element-45" data-mp="24q46vktomr2u" />
        </div>
        <aside className="mt-8 rounded-2xl bg-[#E11D48] px-5 py-6 text-center text-white shadow-[0_16px_34px_rgba(225,29,72,0.25)] sm:px-8" data-id="element-46" data-mp="29ne8dyucit71">
          <p className="text-sm font-bold sm:text-base" data-id="element-47" data-mp="2ehrwrhalc027">
            Valor total de los 5 bonos: <span className="ml-1 text-rose-200 line-through decoration-2" data-id="element-48" data-mp="2ij3nxr944tci">$50.000</span>
          </p>
          <p className="mt-2 text-2xl font-black leading-tight sm:text-3xl" data-id="element-49" data-mp="1lstd2fqtkpus">
            <span className="mr-2" role="img" aria-hidden="true" data-id="element-50" data-mp="1qqczw41l2ayc">🎁</span>
            GRATIS — Incluidos siempre
          </p>
        </aside>
        <aside className="relative mt-6 overflow-hidden rounded-[28px] border-2 border-rose-200 bg-rose-50 px-5 py-7 text-center shadow-[0_14px_35px_rgba(225,29,72,0.08)] sm:px-8 sm:py-8" data-id="element-51" data-mp="1zqhxxnkvzwzu">
          <div className="flex items-center justify-center gap-2 text-xs font-black uppercase tracking-[0.1em] text-[#E11D48] sm:text-sm" data-id="element-52" data-mp="368xxnzy4y1sj">
            <Clock3 className="size-5" aria-hidden="true" data-id="element-53" data-mp="3l9v37rygq5bj" />
            Beneficio de lanzamiento activo
          </div>
          <p className="mt-5 text-lg font-semibold text-[#0C4A6E] sm:text-2xl" style={{
          fontSize: "15px"
        }} data-id="element-54" data-mp="3gbtil2le1xxy">
            Ahorrás <strong className="font-black text-[#E11D48]" data-id="element-55" data-mp="3bhz5ii0agh7u">$8.000 ARS</strong> con la oferta actual.
          </p>
          <div className="mx-auto mt-6 max-w-xl" data-id="element-56" data-mp="37g40p3j5flpb">
            <div className="mb-2 flex items-center justify-between gap-4 text-xs font-bold text-[#475569] sm:text-sm" data-id="element-57" data-mp="32k58f4up9jjm">
              <span data-id="element-58" data-mp="2xifw7lvqqzty">78% de los cursos tomados</span>
              <span className="rounded-md bg-[#CFFAFE] px-2 py-0.5 font-black text-[#075985]" data-id="element-59" data-mp="2sko3ipn9v9op">78%</span>
            </div>
            <div className="h-2.5 overflow-hidden rounded-full bg-white shadow-inner" role="progressbar" aria-label="78% de los cursos tomados" aria-valuemin={0} aria-valuemax={100} aria-valuenow={78} data-id="element-60" data-mp="2ok4a9x5tkq7u">
              <div className="h-full w-[78%] rounded-full bg-[#06B6D4]" data-id="element-61" data-mp="mt0wx04joxjl" />
            </div>
          </div>
          <div className="absolute inset-x-0 bottom-0 h-1.5 bg-[#06B6D4]" aria-hidden="true" data-id="element-62" data-mp="tw7c7g0eqxnq" />
        </aside>
      </div>
    </section>;
}